import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";
export const isImmersiveWorkspace = (type?: string) => type === "TipTap Document Agent";
export default function WorkspaceHeader({ name }: { name?: string; type?: string; workproductId?: string }) {
  return <header className="wp-workspace-header">
    <Link className="wp-workspace-back" to="/documents" title="All documents" aria-label="All documents"><ArrowLeft size={18} /></Link>
    <div className="wp-workspace-identity"><div className="wp-workspace-eyebrow"><FileText size={13} />AI document editor</div><h1>{name || "Untitled document"}</h1></div>
  </header>;
}
